var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiperButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    transform: "matrix(-1 0 0 1 40 0)",
    fill: "#115EF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0575 20.0576L18.6515 25.6515C18.7366 25.7367 18.845 25.7948 18.9631 25.8183C19.0812 25.8419 19.2037 25.8299 19.3149 25.7838C19.4262 25.7377 19.5213 25.6597 19.5882 25.5595C19.6551 25.4594 19.6907 25.3416 19.6907 25.2212L19.6901 20.2356L27.2575 20.2362C27.419 20.2362 27.5739 20.172 27.6881 20.0578C27.8023 19.9436 27.8664 19.7888 27.8664 19.6273C27.8664 19.4658 27.8023 19.3109 27.6881 19.1967C27.5739 19.0825 27.419 19.0184 27.2575 19.0184L19.6901 19.0189L19.6907 14.0333C19.6907 13.9129 19.6551 13.7952 19.5882 13.695C19.5213 13.5949 19.4262 13.5168 19.3149 13.4708C19.2037 13.4247 19.0812 13.4127 18.9631 13.4362C18.845 13.4598 18.7366 13.5178 18.6515 13.603L13.0575 19.197C12.9434 19.3111 12.8793 19.4659 12.8793 19.6273C12.8793 19.7887 12.9434 19.9435 13.0575 20.0576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperButton);
export default __webpack_public_path__ + "static/media/swiper-button.825900f0d1fdad127782dee96823f3e8.svg";
export { ForwardRef as ReactComponent };